<template>
    <div v-show="isVisible()" :class="['s-purchasing-acp-total', `s-purchasing-acp-total-${settings.mode}`]">
        <div class="wrapper">
            <div class="title" v-html="title" />
            <div class="info">
                <div class="price">
                    <p v-if="price.discount" class="price-full" v-html="setCurrency(price.discount + price.current)" />
                    <p class="price-current" v-html="setCurrency(price.current, { zeroByDefault: true })" />
                </div>
                <div class="price-vat" v-html="translation('VAT included')" />
            </div>
        </div>

        <s-warnings
            v-if="settings.mode === 'addons'"
            :list="cloudWarnings"
            @changePage="$emit('changePage', 'expert')"
        />

        <a-button
            v-bind="button"
            :disabled="!price.current"
            @click="handleClick()"
        />
    </div>
</template>

<script>
import AButton from '@core/components/button/button.vue';

import analytics from '@core/mixins/analytics.js';
import cleverbridge from '@core/mixins/cleverbridge.js';
import currency from '@core/mixins/currency.js';
import mixin from '../mixin.js';
import SWarnings from './warnings.vue';

export default {
    name: 'STotal',

    components: {
        AButton,
        SWarnings,
    },

    mixins: [mixin, analytics, currency, cleverbridge],

    props: {
        settings: {
            type: Object,
            default: null,
        },
    },

    emits: ['changePage', 'showLoaderSURL'],

    data: () => ({
        price: {
            discount: 0,
            current: 0,
        },
    }),

    computed: {
        isSimple() {
            return this.settings?.mode === 'simple';
        },

        button() {
            return this.settings?.button || {
                size: 'small',
                type: 'action',
                glyph: 'shopping-cart-o',
                event: { doNotSendGA: true },
                text: this.translation('Proceed to checkout'),
            };
        },

        title() {
            return this.translation(this.settings?.title || 'Subtotal:');
        },
    },

    methods: {
        isVisible() {
            const isPromoActive = this.settings.promo.isPromoActive;
            this.price.discount = isPromoActive ? this.priceTotal('discount_absolute') : 0;
            this.price.current = this.priceTotal('price');
            return this.isSimple || this.price.current;
        },
        handleClick() {
            this.$emit('showLoaderSURL');
            this.onClickBuyButton();
        },
    },
};
</script>

<style lang="postcss" scoped>
.s-purchasing-acp-total {
    .info {
        display: flex;
        text-align: end;
        flex-direction: column;
        color: var(--av-fixed-primary);
    }
    .price-full {
        @mixin paragraph;
        color: var(--av-fixed-light);
        text-decoration: line-through;
    }
    .price-current {
        @mixin title-accent;
    }
    .price-vat {
        @mixin body;
    }
    .a-button {
        @mixin paragraph-accent;
        gap: 8px;
        width: 100%;
        display: flex;
        margin: 16px auto 0;
        justify-content: center;
        flex-direction: row-reverse;
        :deep(.a-glyph) {
            margin: 0;
        }
    }
}

.s-purchasing-acp-total-expert {
    z-index: 2;
    margin-top: auto;
    text-align: center;
    padding: 24px 16px 32px;
    box-shadow: 0 -10px 10px 0 rgba(36, 49, 67, 0.1);
    border-top: 2px solid var(--av-brand-secondary-light);
    border-bottom: 1px solid var(--av-brand-secondary-light);

    @media (--viewport-tablet) {
        bottom: 0;
        position: sticky;
        padding-inline-end: 64px;
        padding-inline-start: 40px;
        background: var(--av-inversed-primary);
    }

    .wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .title {
        @mixin title-accent;
        color: var(--av-nav-primary);
    }
}

.s-purchasing-acp-total-addons {
    margin: 24px 0 0;
    padding: 24px 0 0;
    border-top: 1px solid var(--av-brand-secondary-light);

    .title {
        @mixin nav-title-accent;
        color: var(--av-nav-primary);
    }

    .warnings {
        margin-top: 40px;

        @media (--viewport-tablet) {
            margin-top: 32px;
        }

        @media (--viewport-desktop) {
            margin-top: 64px;
        }
    }

    .info {
        flex-wrap: nowrap;
        margin-top: 16px;
        align-items: flex-start;
        flex-direction: row-reverse;

        @media (--viewport-tablet) {
            flex-direction: column-reverse;
        }

        @media (--viewport-desktop) {
            flex-direction: row-reverse;
        }
    }

    .price {
        flex-direction: column;
        align-items: flex-end;

        @media (--viewport-tablet) {
            width: 100%;
            align-items: end;
            margin-top: 40px;
        }

        @media (--viewport-desktop) {
            margin: 0;
        }
    }

    .price-vat {
        text-align: start;
        white-space: nowrap;
    }

    :deep(.a-button) {
        @mixin paragraph-accent;
        margin-top: 32px;
    }
}
</style>
